/**
 * @param {import("axios").AxiosError} error
 * @param {string=} context - a custom descriptive error message
 * @returns void
 */
export const handleGlobalError = (vm, error, context) => {
  let message = 'Unknown error.  Please try again or contact support. '
  if (!error.response) {
    message = `Error trying to ${context}.  Please try again or contact support.`
    vm.$bvToast.toast(message, {
      title: 'Encountered an error',
      variant: 'danger',
      solid: true,
      toaster: 'b-toaster-top-center',
    })
  } else {
    if (error.response.data && error.response.data.message) {
      // commenting out for Paul's QC
      message = `Error trying to ${context}.  Please try again or contact support.  Detail: ${error.response.data.message}`
      // message = `Error trying to ${context}.  Please try again or contact support.  Detail: ${error.response.status} ${error.response.data.message}`
      // message = `Error trying to ${context}.  Please try again or contact support.`
    } else {
      message = `Error trying to ${context}.  Please try again or contact support.`
    }

    if (error.response.status === 403) {
      console.log('unauthorized access')
      vm.$bvToast.toast(message, {
        title: 'Unauthorized Error',
        variant: 'danger',
        solid: true,
        toaster: 'b-toaster-top-center',
        noAutoHide: true,
      })
    } else if (error.response.status === 401) {
      if (error.response.data && error.response.data.message === 'Invalid login') {
        vm.$root.$bvToast.toast('Email address and/or password is invalid.  Please try again.', {
          title: 'Invalid Login',
          variant: 'warning',
          solid: true,
          toaster: 'b-toaster-top-center',
        })
      } else {
        console.log('handling expired session')
        // logout
        // Use a shorter name for `this.$createElement`
        const h = vm.$createElement
        const $closeButton = h(
          'button',
          {
            on: { click: () => logout(vm, vm.id) },
          },
          'Login'
        )

        vm.$root.$bvToast.toast(['Session has expired. Please login again.  ', $closeButton], {
          title: 'Session Expired',
          variant: 'warning',
          solid: true,
          toaster: 'b-toaster-top-center',
          noAutoHide: true,
        })
      }
    } else if (error.response.status === 400) {
      vm.$bvToast.toast(message, {
        title: 'Warning',
        variant: 'warning',
        solid: true,
        toaster: 'b-toaster-top-center',
        noAutoHide: true,
      })
    } else if (error.response.status === 500) {
      vm.$bvToast.toast(message, {
        title: 'Error',
        variant: 'danger',
        solid: true,
        toaster: 'b-toaster-top-center',
        noAutoHide: true,
      })
    } else {
      vm.$bvToast.toast(message, {
        title: 'Error',
        variant: 'danger',
        solid: true,
        toaster: 'b-toaster-top-center',
        noAutoHide: true,
      })
    }
  }
}

function logout(vm, id) {
  vm.$root.$bvToast.hide(id)
  document.dispatchEvent(new Event('startLogoutSession')) // The function returns the product of p1 and p2
}

/**
 *
 * @param {number} amt
 * @param {number} fixed
 * @returns {string}
 */
export const convertFromMutez = (amt, fixed = 3) => {
  return (amt / 1000000).toFixed(fixed)
}

/**
 *
 * @param {number} amt
 * @returns {number}
 */
export const convertToMutez = (amt) => {
  return amt * 1000000
}
